import HYRO_THEME from "./index";

export const getGlobalStyles = (theme) => ({
  "*": {
    scrollbarColor: `${theme.palette.grey[300]} transparent`
  },
  body: {
    color: HYRO_THEME.palette.text[800],
    "& .MuiDrawer-root .MuiBackdrop-root": { backgroundColor: "rgba(22, 20, 83, 0.5)" }
  },
  button: {
    // TODO: Remove this once we use HyroButton everywhere
    // and we have letterSpacing in all the typography styles.
    letterSpacing: "0.2px"
  }
});
